<template>
  <v-dialog v-model="dialog" scrollable max-width="500">
    <v-card>
      <v-card-title>
        役職情報編集
        <v-spacer />
        <IconButton icon="mdi-close" @click="cancel" />
      </v-card-title>

      <v-card-text>
        <v-form ref="staff_form">
          <v-container>
            <v-row>
              <v-col cols="6">
                <FormInputComponent
                  label="表示順"
                  type="number"
                  v-model="showOrder"
                  rules="required"
                  :counter="4"
                />
              </v-col>
              <v-col cols="12">
                <FormInputComponent
                  label="役職名"
                  v-model="posotionName"
                  rules="required"
                  :counter="20"
                />
              </v-col>
              <v-col cols="12">
                <FormInputComponent
                  label="役職名ふりがな"
                  v-model="posotionNameFurigana"
                  rules="required"
                  :counter="20"
                />
              </v-col>
            </v-row>
            <v-row v-if="loading"
              ><v-col><Loader :loading="loading" /></v-col
            ></v-row>
            <v-row>
              <v-col>
                <Button @click="erntry_confirm" color="primary">登録</Button>
              </v-col>
              <v-col v-if="!entryFlg">
                <Button @click="delete_confirm" color="danger">削除</Button>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <ConfirmDialog
        ref="confirm"
        title="役職情報編集"
        :message="confirmMessage"
        buttonMessage="OK"
        @confirm="editPositionInfo"
      >
      </ConfirmDialog>

      <DialogMessage ref="dialog" />
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import moment from 'moment';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import { getSessionStorageItem, isNumber } from '@/common.js';

export default {
  components: {
    ConfirmDialog,
  },
  data: () => ({
    dialog: false,
    confirm: false,
    entryFlg: false,
    editFlg: false,
    deleteFlg: false,
    resolve: null,
    reject: null,

    loading: false,
    confirmMessage: null,

    positionId: null,
    organaizationKey: null,

    // 表示順序
    showOrder: 0,
    // 役職名
    posotionName: null,
    // 役職名フリガナ姓
    posotionNameFurigana: null,
    posotionNameFuriganaRules: [(v) => !!v || '必須入力項目です'],

    expiration: null,
    createdAt: null,
    updateAt: null,

    options: {
      color: 'primary',
      width: 300,
    },
  }),
  created() {},
  methods: {
    open(item, options) {
      this.dialog = true;
      this.confirm = false;
      this.input_image = null;
      this.uploadImageUrl = '';

      if (item == null) {
        this.entryFlg = true;
        this.editFlg = false;
        (this.positionId = null),
          (this.organaizationKey = null),
          (this.showOrder = null),
          (this.posotionName = null),
          (this.posotionNameFurigana = null),
          (this.expiration = null),
          (this.createdAt = null),
          (this.updateAt = null);
      } else {
        this.entryFlg = false;
        this.editFlg = true;

        this.positionId = item.POSITION_ID;
        this.organaizationKey = item.ORGANIZATION_KEY;
        (this.showOrder = item.SHOW_ORDER),
          (this.posotionName = item.POSITION_NAME),
          (this.posotionNameFurigana = item.POSITION_NAME_FURIGANA),
          (this.expiration = item.EXPIRATION),
          (this.createdAt = item.CREATED_AT);
        this.updateAt = item.UPDATED_AT;
      }
      this.options = Object.assign(this.options, options);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.staff_form.validate()) {
        return;
      }
      // 表示順数値チェック
      if (!isNumber(this.showOrder)) {
        let warnStr = message.MSG_WARN_SHOWO_ORDER_ERROR;
        let warnStrReplace = warnStr.replace(/a/g, '表示順');
        this.$refs.dialog.open('warning', warnStrReplace);
        return;
      }
      // 役職名称存在チェック
      this.checkPositionExists();
    },
    async delete_confirm() {
      // 入力チェック
      if (!this.$refs.staff_form.validate()) {
        // チェックエラー
        return;
      }

      // ローディング画像表示
      this.loading = true;

      let userInfo = getSessionStorageItem();
      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/members/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY +
            '/' +
            config.EMPTY_STRING +
            '/' +
            config.EMPTY_STRING
        )
        .then((response) => {
          // 役職データ取得
          this.loading = false;

          let hasPosition = false;
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].POSITION_NAME == this.posotionName) {
              hasPosition = true;
              break;
            }
          }
          if (hasPosition) {
            let msgStr =
              '[' +
              this.posotionName +
              ']の役職情報は、既に使用されているため削除できません。';
            this.$refs.dialog.open('info', msgStr);
            return;
          } else {
            // 確認ダイアログ表示
            this.deleteFlg = true;
            this.confirmMessage =
              '[' + this.posotionName + ']の役職情報を削除しますか？';
            this.$refs.confirm.open();
          }
        })
        .catch((error) => {
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
          return;
        });
    },
    checkPositionExists() {
      // ローディング画像表示
      this.loading = true;

      let userInfo = getSessionStorageItem();
      axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/position/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 役職データ取得
          this.loading = false;

          let usePosition = false;
          for (let i = 0; i < response.data.length; i++) {
            if (this.posotionName == response.data[i].POSITION_NAME) {
              usePosition = true;
              break;
            }
          }
          if (usePosition) {
            let msgStr =
              '[' +
              this.posotionName +
              ']の役職情報は、既に存在するため登録できません。';
            this.$refs.dialog.open('info', msgStr);
            return;
          } else {
            // 確認ダイアログ表示
            this.deleteFlg = false;
            this.confirmMessage =
              '[' + this.posotionName + ']の部署情報を登録しますか？';
            this.$refs.confirm.open();
          }
        })
        .catch((error) => {
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
          return;
        });
    },
    editPositionInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      if (this.deleteFlg) {
        // 削除処理
        this.deletePositionInfoRequest();
      } else {
        // 登録処理
        this.editPositionInfoRequest();
      }
    },
    editPositionInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // ユーザ情報作成
      if (this.entryFlg) {
        // 新規登録
        this.positionId =
          userInfo.ORGANIZATION_KEY + moment().format('YYYYMMDDHHmmss');
        this.createdAt = moment().format('YYYYMMDDHHmmss');
      }

      // 共通
      this.expiration = '0'; // 使用開始
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- 役職情報登録リクエストPOST
      axios
        .post(config.CONNECT_URL + '/Encouragements/manage/position/entry', {
          SESSION_ID: userInfo.SESSION_ID,
          SESSION_USER_ID: userInfo.USER_ID,

          POSITION_ID: this.positionId,
          ORGANIZATION_KEY: userInfo.ORGANIZATION_KEY,
          POSITION_NAME: this.posotionName,
          POSITION_NAME_FURIGANA: this.posotionNameFurigana,
          SHOW_ORDER: this.showOrder,
          EXPIRATION: this.expiration,
          CREATED_AT: this.createdAt,
          UPDATED_AT: this.updateAt,
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = message.MSG_INFO_POSITION_ENTRY_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    deletePositionInfoRequest() {
      // ローディング画像表示
      this.loading = false;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // 新規登録モードの場合は処理終了
      if (this.entryFlg) {
        return;
      }

      //----- 役職情報削除リクエストPOST
      axios
        .post(config.CONNECT_URL + '/Encouragements/manage/position/delete', {
          SESSION_ID: userInfo.SESSION_ID,
          SESSION_USER_ID: userInfo.USER_ID,
          POSITION_ID: this.positionId,
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr =
              this.posotionName + message.MSG_INFO_POSITION_DELETE_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
<style>
.inner {
  padding-top: 10px;
  display: flex;
  justify-content: space-evenly;
}
</style>
